module.exports = __webpack_public_path__ + "static/media/marker_white.b76cdfa1.svg";